import axios from 'axios'
import security from '@/services/security.js'

export default {
  getReceipts (courseKey, isIncome) {
    const config = { headers: security.getAuthHeader() }
    return axios.get('/finance/receipt/' + courseKey + '/' + isIncome, config)
      .then(response => {
        return response.data
      })
  },
  updateReceiptItem (courseKey, item) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/finance/receipt/' + courseKey + '/item', item, config)
      .then(response => {
        return response.data
      })
  },
  updateReceipt (courseKey, receipt) {
    const config = { headers: security.getAuthHeader() }
    return axios.post('/finance/receipt/' + courseKey, receipt, config)
      .then(response => {
        return response.data
      })
  },
  deleteReceiptItem (courseKey, receiptId, itemId) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/finance/receipt/' + courseKey + '/' + receiptId + '/item/' + itemId, config)
      .then(response => {
        return response.data
      })
  },
  deleteReceipt (courseKey, receiptId, isIncome) {
    const config = { headers: security.getAuthHeader() }
    return axios.delete('/finance/receipt/' + courseKey + '/' + isIncome + '/' + receiptId, config)
      .then(response => {
        return response.data
      })
  }
}
